import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import "./Navbar.scss";
import logo from "../../Assets/Images/logo.png";
import discord from '../../Assets/Icons/discordLogo.svg'
import twitter from '../../Assets/Icons/twitterLogo.svg'
import instagram from '../../Assets/Icons/instagramLogo.svg'


const Navbar = ({ homeNav }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <div id="navbar">
      <nav className={homeNav}>
        <div className="container-fluid navbarWidth ">
          <a href="/">
            <img className="navlogo" src={logo} alt="logo" />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={handleShow}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
              <ul className="navbar-nav">
                <li className="nav-item">
                  <a
                    className="nav-link"
                    activeClassName={"current"}
                    href="/#about"
                    onClick={handleClose}
                  >
                    About
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    activeClassName={"current"}
                    href="/#success"
                    onClick={handleClose}
                  >
                    Success
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    activeClassName={"current"}
                    href="/#features"
                    onClick={handleClose}
                  >
                    Features
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    activeClassName={"current"}
                    href="/#plan"
                    onClick={handleClose}
                  >
                    Purchase
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    activeClassName={"current"}
                    href="/#faq"
                    onClick={handleClose}
                  >
                    FAQ
                  </a>
                </li>
                {/* <li className="nav-item ms-md-3">
                  <a
                    className="nav-link"
                    activeClassName={"current"}
                    href="/"
                    onClick={handleClose}
                  >
                    Support
                  </a>
                </li> */}
              </ul>
              <ul className="socialContainer">
                <li className="nav-item">
                  <a href="https://whop.com/freebiefrenzy" target="_blank" rel="noreferrer">
                    <img className="socialLogo" src={discord} alt="logo" />
                  </a>
                </li>
                <li className="nav-item">
                  <a href="https://twitter.com/freebiefrenzy" rel="noreferrer">
                    <img className="socialLogo" src={twitter} alt="logo" />
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/">
                    <img className="socialLogo" src={instagram} alt="logo" />
                  </a>
                </li>
              </ul>
            </Modal.Body>
          </Modal>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <ul className="navbar-nav me-auto pe-3 mt-1 mb-md-0 scrollspy">
              <li className="nav-item ms-md-3">
                <a
                  className="nav-link"
                  activeClassName={"current"}
                  href="/#about"
                >
                  About
                </a>
              </li>
              <li className="nav-item ms-md-3">
                <a
                  className="nav-link"
                  activeClassName={"current"}
                  href="/#success"
                >
                  Success
                </a>
              </li>
              <li className="nav-item ms-md-3">
                <a
                  className="nav-link"
                  activeClassName={"current"}
                  href="/#features"
                >
                  Features
                </a>
              </li>
              <li className="nav-item ms-md-3">
                <a
                  className="nav-link"
                  activeClassName={"current"}
                  href="/#plan"
                >
                  Purchase
                </a>
              </li>
              <li className="nav-item ms-md-3">
                <a
                  className="nav-link"
                  activeClassName={"current"}
                  href="/#faq"
                >
                  FAQ
                </a>
              </li>
              {/* <li className="nav-item ms-md-3">
                <a
                  className="nav-link"
                  activeClassName={"current"}
                  href="/"
                >
                  Support
                </a>
              </li> */}
            </ul>
            <ul className="socialContainer">
              <li className="nav-item">
                <a href="https://whop.com/freebiefrenzy" target="_blank" rel="noreferrer">
                  <img className="socialLogo" src={discord} alt="logo" />
                </a>
              </li>
              <li className="nav-item">
                <a href="https://twitter.com/freebiefrenzy" rel="noreferrer" target="_blank">
                  <img className="socialLogo" src={twitter} alt="logo" />
                </a>
              </li>
              <li className="nav-item">
                <a href="/#">
                  <img className="socialLogo" src={instagram} alt="logo" />
                </a>
              </li>
            </ul>
            <form className="d-flex">
              <a href="/#plan">
                <div className="btn purchaseButton text-nowrap">Buy Now</div>
              </a>
            </form>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
